import { Type } from '@angular/core';
export class Line {
  constructor(
    public component: Type<any>,
    public url: Function,
    public options: any,
    public sessionId: any,
    public filters: any,
    public filter: any
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/line/line.ts